import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'antd'
import { useSelector } from 'react-redux'
import {
  exportUndoRecord,
  findPlantModules,
  findUndoOperatorList,
  findUndoWriteOffBatchNoList,
  queryUndoRecordPage
} from '@/services/writeOff/writeOff'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import {
  downLoadFileBlob,
  formatMessage,
  formatMessageNew,
  formatSpcEndTime,
  formatSpcStartTime,
  paginationInit
} from '@/utils/common'

const dateFormat = 'YYYY-MM-DD HH:mm:ss'
const batchStatusOptions = [
  { label: 'Open', value: 'Open' },
  { label: 'Scanning', value: 'Scanning' },
  { label: 'Scan Complete', value: 'Scan Complete' },
  { label: 'Submitted', value: 'Submitted' },
  { label: 'Disabling', value: 'Disabling' },
  { label: 'Closed', value: 'Closed' },
  { label: 'Fail', value: 'Fail' }
]

const UIDCollectionUndoRecord = () => {
  const commonStore = useSelector(state => state.commonStore)
  const languageState = useSelector(state => state.commonStore.language)
  const formRef = useRef(null)
  const mounting = useRef(false)
  const [tableList, setTableList] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.writeOff.batchNumber',
      key: 'batchNoList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.writeOff.plant',
      key: 'plantList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRangeSpc',
      label: 'languageObj.writeOff.undoDate',
      key: 'undoDate',
      format: dateFormat,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.writeOff.undoSku',
      key: 'sku',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.writeOff.undoUpc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.writeOff.batchStatus',
      key: 'batchStatusList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: batchStatusOptions,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.writeOff.undoOperator',
      key: 'undoOperatorList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)

  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.batchNumber'),
      dataIndex: 'batchNo',
      width: 140,
      fixed: 'left'
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.batchStatus'),
      dataIndex: 'batchStatus',
      width: 130,
      fixed: 'left'
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.plant'),
      dataIndex: 'plant',
      width: 90
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.undoSku'),
      dataIndex: 'sku',
      width: 140
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.undoUpc'),
      dataIndex: 'upc',
      width: 140
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.undoOperator'),
      dataIndex: 'undoOperator',
      width: 150
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.undoDate'),
      dataIndex: 'undoDate',
      width: 180
    }
  ]

  useEffect(() => {
    getDictionnaryDropListFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDictionnaryDropListFun = () => {
    let param = {
      isConfig: false
    }
    Promise.all([findPlantModules(param), findUndoWriteOffBatchNoList(), findUndoOperatorList()]).then(res => {
      try {
        searchListInit.forEach(searchItem => {
          if (['plantList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'plantList':
                const plantCodeList = res[0].resultData
                const plantOptions = plantCodeList.map(item => ({ value: item, label: item }))
                options = [...plantOptions]
                break
              default:
                break
            }
            searchItem.selectList = options
          }
          if (['batchNoList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'batchNoList':
                const batchNoList = res[1].resultData
                const batchNoOptions = batchNoList.map(item => ({ value: item, label: item }))
                options = [...batchNoOptions]
                break
              default:
                break
            }
            searchItem.selectList = options
          }
          if (['undoOperatorList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'undoOperatorList':
                const undoOperatorList = res[2].resultData
                const undoOperatorOptions = (undoOperatorList || []).map(item => ({ value: item, label: item }))
                options = [...undoOperatorOptions]
                break
              default:
                break
            }
            searchItem.selectList = options
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {}
    })
  }

  const buildRequestParams = pageInfo => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    return {
      batchNoList: info.batchNoList && info.batchNoList.length > 0 ? info.batchNoList : null,
      plantList: info.plantList && info.plantList.length > 0 ? info.plantList : null,
      undoDateStart: formatSpcStartTime(info.undoDate),
      undoDateEnd: formatSpcEndTime(info.undoDate),
      sku: info.sku ? String(info.sku).trim() : '',
      upc: info.upc ? String(info.upc).trim() : '',
      batchStatusList: info.batchStatusList && info.batchStatusList.length > 0 ? info.batchStatusList : null,
      undoOperatorList: info.undoOperatorList && info.undoOperatorList.length > 0 ? info.undoOperatorList : null,
      isChinese: languageState === 'zh_CN',
      pageNo: pageInfo.currentPage,
      size: pageInfo.pageSize
    }
  }

  const searchDataFun = pageInfo => {
    queryUndoRecordPage(buildRequestParams(pageInfo)).then(res => {
      const dt = res && res.resultData ? res.resultData : {}
      const records = Array.isArray(dt.records) ? dt.records : []
      setTableList(records)
      setPagination(prev => ({
        ...prev,
        ...pageInfo,
        total: dt.total || 0
      }))
    })
  }

  const searchDataBtn = () => {
    mounting.current = true
    const nextPagination = {
      ...pagination,
      currentPage: 1
    }
    setPagination(nextPagination)
    searchDataFun(nextPagination)
  }

  const searchClearDataBtn = () => {
    formRef.current && formRef.current.clearForm()
    mounting.current = false
    setPagination({
      ...paginationInit,
      total: 0
    })
    setTableList([])
  }

  const handleTableChange = pagina => {
    const nextPagination = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination(nextPagination)
    if (mounting.current) {
      searchDataFun(nextPagination)
    }
  }

  const downLoadFun = () => {
    exportUndoRecord(buildRequestParams(pagination)).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }} />
          <AntdTable
            dataSource={tableList}
            columns={tableColumns}
            columnsKey="uidCollectionUndoRecordColumns"
            pagination={pagination}
            onChange={handleTableChange}
          />
          {!tableList.length && (
            <div style={{ color: '#999', textAlign: 'center', padding: '12px 0 0' }}>
              {formatMessageNew('languageObj.commonLocale.noData')}
            </div>
          )}
        </div>
      </Card>
    </div>
  )
}

export default UIDCollectionUndoRecord
